import { ExportColumn } from '@app/src/types/export'

export const StandardAssessmentsExportColumnsAccessor: ExportColumn[] = [
  {
    translationId: 'assessments.export.name',
    exportPath: 'assessmentTemplate.name',
  },
]
